import { useEffect, useState } from "react";
import { connect } from "react-redux";
import DocumentMeta from "react-document-meta";
import { withRouter, Link } from "react-router-dom";
import RevSlider, { Slide, Caption } from "react-rev-slider";
import Slider from "react-slick";
import parse from "html-react-parser";
import swal from "sweetalert";

// import becomementor from "../../../../assets/images/become-mentor.png";
import becomementor from "../../../../assets/images/Orange button Rectangle.svg";
// import findMentorImg from "../../../../assets/images/apply-get-mentor.png";
import findMentorImg from "../../../../assets/images/Purple button Rectangle.svg";
import bannerbg from "../../../../assets/images/banner-bg.jpg";
import sliderImg from "../../../../assets/images/slide1-mckp6.png";
import sliderImg2 from "../../../../assets/images/slide2-mckp6.png";
import bg7Img from "../../../../assets/images/impact-created.png";
import "./styles.scss";
// import findMentor2 from '../../../../assets/images/find-mentor.png';
// import bg1 from "../../../../assets/images/banner-bg1.jpg";

import bg1 from "../../../../assets/images/about-banner-bg.jpg";
// import LoginForm from '../../../Auth/LoginForm';
// import { Tooltip } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "./Modal/modal";

import { useTranslation } from "react-i18next";
const StartUp = (props) => {
  //
  const [isShowLogin, setIsShowLogin] = useState(false);

  //change this to true to show, and false to hide
  const [modalOpen, setModalOpen] = useState(true);
  const { t } = useTranslation();
  const history = useHistory();

  // var settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 3000,
  // };
  // //

  const config = {
    delay: 9000,
    startwidth: 1170,
    startheight: 500,
    hideThumbs: 10,
    fullWidth: "on",
    forceFullWidth: "on",
  };
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    rtl: true,

    arrows: false,
  };
  const meta = {
    title: "MAARG",
    description:
      "The Waste to Wealth Mission brings scientific processing of waste to the forefront to build a zero landfill and zero waste nation. The portal shall act as a common platform for technology providers, government stakeholders, urban local bodies, and users to seek relevant solutions.",
    canonical: "https://www.wastetowealth.gov.in/",
    meta: {
      charset: "utf-8",
      name: {
        keywords:
          "Mentorship,startupindia,Wealth,waste,wealth,Waste to Wealth Mission,Swachh Bharat Mission,W2W Missions",
      },
    },
  };

  const data = [
    {
      name: "Banner A",
      image: "https://sensez9.tech/MNP/assets/images/tm-1.jpg",
      slider: props.data ? props.data[0].BannerImage : sliderImg,
    },
    {
      name: "Banner B",
      image: "https://sensez9.tech/MNP/assets/images/tm-2.jpg",
      slider: props.data ? props.data[1].BannerImage : sliderImg,
    },
    {
      name: "Banner C",
      image: "https://sensez9.tech/MNP/assets/images/tm-2.jpg",
      slider: props.data ? props.data[2].BannerImage : sliderImg,
    },
  ];
  const renderSlides = [1, 2, 3, 4, 5, 6, 7, 8];
  const imageClick = () => {
    //
    try {
      let value = localStorage.getItem("SavedLoggedInData");
      //
      let Data = JSON.parse(value);
      //
      if (localStorage.getItem("loggedIn") === "true") {
        history.push({
          pathname: "/become-a-mentor",
          state: Data,
        });
      } else {
        history.push({
          pathname: "/login",
          state: Data,
        });
      }
    } catch (error) {}
  };
  const handleLoginClick = (buttonAction) => {
    try {
      // if(buttonAction=="Startup"){
      //   history.push({
      //     pathname: "/coming-soon"
      //   });
      // }else{
      localStorage.removeItem("activePage");
      // if (
      //   localStorage.getItem("loggedIn") == null ||
      //   localStorage.getItem("loggedIn").length !== 0
      // ) {
      //   if (localStorage.getItem("loggedIn") === "true") {

      //     let value = localStorage.getItem("SavedLoggedInData");
      //     let LoginFormData = JSON.parse(value);
      //     if (
      //       LoginFormData?.role == "Startup" &&
      //       LoginFormData?.role === buttonAction
      //     ) {
      //       history.push({
      //         pathname: "/startup-form",
      //         state: LoginFormData,
      //       });
      //     } else if (
      //       LoginFormData?.role == "Mentor" &&
      //       LoginFormData?.role === buttonAction
      //     ) {
      //       history.push({
      //         pathname: "/become-a-mentor",
      //         state: LoginFormData,
      //       });
      //     } else {
      //       // alert("You have Already Logged In with "+buttonAction)

      //       toast.error(
      //         "You have Already Logged In with " +
      //           LoginFormData?.role +
      //           ", Logout First..."
      //       );
      //     }
      //     // history.push({
      //     //   pathname: "/get-a-mentor",
      //     //   state:Data ,
      //     // });
      //   } else {

      //     localStorage.removeItem("SavedLoggedInData");
      //     localStorage.removeItem("loggedIn");

      //     history.push({
      //       pathname: "/login",
      //       state: buttonAction,
      //     });
      //   }
      // } else {

      //   localStorage.removeItem("SavedLoggedInData");
      //   localStorage.removeItem("loggedIn");
      //   history.push({
      //     pathname: "/login",
      //   });
      // }

      if (localStorage.getItem("loggedIn") == null) {
        history.push({
          pathname: "/login",
          state: buttonAction,
        });
      } else {
        if (localStorage.getItem("loggedIn") === "true") {
          let value = localStorage.getItem("SavedLoggedInData");
          let LoginFormData = JSON.parse(value);
          if (
            LoginFormData?.role == "Startup" &&
            LoginFormData?.role === buttonAction
          ) {
            if (LoginFormData?.applicationStatus != "PENDING") {
              history.push({
                pathname: "/dashboard",
                state: LoginFormData,
              });
            } else {
              history.push({
                pathname: "/get-a-mentor",
                state: LoginFormData,
              });
            }

            // history.push({
            //   pathname: "/get-a-mentor",
            //   state: LoginFormData,
            // });
          } else if (
            LoginFormData?.role == "Mentor" &&
            LoginFormData?.role === buttonAction
          ) {
            if (LoginFormData?.applicationStatus != "PENDING") {
              history.push({
                pathname: "/dashboard",
                state: LoginFormData,
              });
            } else {
              history.push({
                pathname: "/become-a-mentor",
                state: LoginFormData,
              });
            }
          } else {
            toast.error(
              "You have Already Logged In with " +
                LoginFormData?.role +
                ", Logout First..."
            );
          }
        } else {
          history.push({
            pathname: "/login",
            state: buttonAction,
          });
        }
      }
    } catch (error) {}

    setIsShowLogin(!isShowLogin);
  };
  return (
    <div className="blog-wrap position-relative w-100 wow slideInLeft startuphome">
      <Modal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        // modalData={modalData}
      />
      <div
        className="background-gradient"
        //   style={{
        // backgroundImage: { bg1 },
        //     backgroundPosition: "center",
        //     backgroundSize: "cover",
        //   }}
      >
        <div className="row post-caro2">
          <Slider {...settings}>
            {data &&
              Array.isArray(data) &&
              data.length > 0 &&
              data.map((value, index) => {
                return (
                  <div>
                    <div className="row-homebanner">
                      <div>
                        <img
                          height="467"
                          width="463"
                          src={value.slider}
                          style={{ marginTop: "120px" }}
                          alt="Slide 1 Mockup 6"
                        />
                      </div>
                      <div className="homepage-intro">
                        <div>
                          <h2 className="mb-0 homepageFirstHeader">
                            MAARG Portal
                            <br /> by Startup India
                            {/* Startup India <br></br> National Mentorship Platform */}
                            {/* {props.data
                              ? parse(props.data[0].BannerTitle)
                              : parse("MAARG Portal<br/> by Startup India")} */}
                          </h2>
                        </div>
                        <div
                          style={{
                            lineHeight: "25px",
                            fontFamily: "Montserrat",
                            fontSize: "20px",
                            letterSpacing: "0",
                            fontWeight: "400",
                            color: "#3e4a59",
                            marginTop: "15px",
                            marginBottom: "15px",
                          }}
                          className="homepageFirstDescription"
                        >
                          {t("Enabling_the_enterpreneurship_vision_for_India")}{" "}
                          <br />
                          {localStorage.getItem("SelectedLang") == "en"
                            ? t("expert_mentorships_and_programs")
                            : t("expert_mentorships_and_programs")}
                          {/* Enabling the enterpreneurship vision for India through<br></br>{" "}
                       
                         expert mentorships and programs. */}
                        </div>
                        <div>
                          <div className="center-btns">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                              }}
                              className="tp-caption mentorApplication-button top-btn row newuserTooltip"
                              id="slide1-layer-14"
                              data-x="['center','center','center','center']"
                              data-hoffset="['200','200','200','50']"
                              data-y="['middle','middle','middle','middle']"
                              data-voffset="['-1','-1','120','120']"
                              data-width="none"
                              data-height="none"
                              data-whitespace="nowrap"
                              data-type="text"
                              data-actions='[{"event":"click","action":"simplelink","slide":"next","delay":"","target": "_self" }]'
                              data-responsive_offset="on"
                              data-responsive="on"
                              data-frames='[{"delay":1500,"speed":1500,"frame":"0","from":"x:50px;opacity:0;","to":"o:1;","ease":"Power3.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"x:50px;opacity:0;","ease":"Power2.easeInOut"}]'
                              //  data-textAlign="['center','center','center','center']"
                              data-paddingtop="[20,17,14,12]"
                              data-paddingright="[55,40,35,30]"
                              data-paddingbottom="[20,17,14,12]"
                              data-paddingleft="[55,40,35,30]"
                              onClick={() => handleLoginClick("Startup")}
                            >
                              {" "}
                              <img
                                className="homebtndiv1"
                                height="auto"
                                width="100%"
                                //   onClick={() => swal("Please stay tuned, this function will be enabled shortly after the launch of Startup onboarding process.",
                                //   {closeOnClickOutside: false}
                                // )
                                // //  handleLoginClick("Startup")
                                // }
                                src={findMentorImg}
                                alt="Slide 1 Mockup 6 "
                                // style={{
                                //   width: "90%",
                                // }}
                              />
                              <div
                                class="centered col-lg-6 col-md-6 col-sm-2 homebtn1"
                                // style={{ left: "80px", lineHeight: "25px" }}
                              >
                                Startup Application
                              </div>
                              <span className="tooltiptext homepageButtons tooltip-bottom">
                                Click to Apply as a Startup
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                              }}
                              className="tp-caption mentorApplication-button top-btn row newuserTooltip"
                              id="slide1-layer-13"
                              data-x="['right','right','right','right']"
                              data-hoffset="['100','100','100','200']"
                              data-y="['middle','middle','middle','middle']"
                              data-voffset="['-1','-1','120','120']"
                              data-width="none"
                              data-height="none"
                              data-whitespace="nowrap"
                              data-type="text"
                              data-actions='[{"event":"click","action":"simplelink","slide":"next","delay":"","target": "_self"}]'
                              data-responsive_offset="on"
                              data-responsive="on"
                              data-frames='[{"delay":1000,"speed":1000,"frame":"0","from":"x:50px;opacity:0;","to":"o:1;","ease":"Power3.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"x:50px;opacity:0;","ease":"Power2.easeInOut"}]'
                              //  data-textAlign="['center','center','center','center']"
                              data-paddingtop="[20,17,14,12]"
                              data-paddingright="[55,40,35,30]"
                              data-paddingbottom="[20,17,14,12]"
                              data-paddingleft="[55,40,35,30]"
                              onClick={() => handleLoginClick("Mentor")}
                            >
                              <img
                                className="homebtndiv2"
                                height="auto"
                                width="100%"
                                src={becomementor}
                                alt="Slide 1 Mockup 6 "
                                // style={{
                                //   width: "90%",
                                // }}
                              />
                              <div
                                class="centered col-lg-6 col-md-6 col-sm-2 homebtn2"
                                // style={{
                                //   left: "auto",
                                //   lineHeight: "25px",
                                //   right: "85px",
                                // }}
                              >
                                Mentor Application
                              </div>
                              <span className="tooltiptext homepageMentor tooltip-bottom">
                                Click to Apply as a Mentor
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* </div> */}
                    {/* <div className="post-box brd-rd15 w-100">
              <div className="team-box text-center position-relative w-100">
                <div className="team-img w-100">
                  <a href="javascript:void(0);" title="">
                    <img
                      className="img-fluid w-100"
                      src={value.image ?value.image :"https://sensez9.tech/MNP/assets/images/tm-6.jpg"}
                      alt="Team Image 1"
                      height="300"
                      width="300"
                    />
                  </a>
                </div>
                <div className="team-info w-100">
                  <h3 className="mb-0">
                    <a href="javascript:void(0);" title="">
                      {value.applicant_name}
                    </a>
                  </h3>
                  <span className="d-block">
                    <a href="javascript:void(0);" title="">
                    {value.city ?value.city :""} , { value.state?value.state :""  }
                     
                    </a>
                  </span>
                  <div className="social-links v2 d-inline-flex flex-wrap"></div>
                </div>
              </div>
            </div>
          */}
                  </div>
                );
              })}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default StartUp;
